import React from "react";
import { Link, useLocation } from "react-router-dom";
import { RotateCw, Dice5, Target, Pickaxe, ArrowUpDown, CircleDot, TowerControl, Rocket, CircleDollarSign } from "lucide-react";
import { useApp } from "../context/AppContext";

const GAMES = [
  { to: "/games/roulette", label: "Roulette", icon: RotateCw },
  { to: "/games/mini-roulette", label: "Mini Roulette", icon: Target },
  { to: "/games/pro-roulette", label: "Pro Roulette", icon: Target },
  { to: "/games/dice", label: "Dice", icon: Dice5 },
  { to: "/games/mines", label: "Mines", icon: Pickaxe },
  { to: "/games/hilo", label: "Hi-Lo Rush", icon: ArrowUpDown },
  { to: "/games/plinko", label: "Plinko", icon: CircleDot },
  { to: "/games/tower", label: "Tower", icon: TowerControl },
  { to: "/games/limbo", label: "Limbo", icon: Rocket },
  { to: "/games/coinflip", label: "Coin Flip", icon: CircleDollarSign },
];

export default function GamesBar() {
  const { isAuthed } = useApp();
  const location = useLocation();
  if (!isAuthed) return null;

  return (
    <div
      data-testid="games-bar"
      className="fixed bottom-5 left-1/2 -translate-x-1/2 z-50 hidden lg:flex items-center gap-1.5 rounded-full glass border border-border px-2 py-1.5 shadow-2xl max-w-[95vw] overflow-x-auto no-scrollbar"
    >
      <span className="hidden sm:block pl-2 pr-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground shrink-0">Games</span>
      {GAMES.map((g) => {
        const Icon = g.icon;
        const active = location.pathname === g.to;
        return (
          <Link
            key={g.to}
            to={g.to}
            data-testid={`games-bar-${g.label.toLowerCase()}`}
            className={`flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold transition-colors shrink-0 whitespace-nowrap ${
              active ? "bg-primary text-primary-foreground" : "text-foreground hover:bg-white/5"
            }`}
          >
            <Icon className="h-4 w-4" />
            {g.label}
          </Link>
        );
      })}
    </div>
  );
}
